import { FadeImage } from "./FadeImage";

const TIER_MAX = {
  feature: "max-w-[1100px]",
  standard: "max-w-[720px]",
  archival: "max-w-[420px]",
};

export const Figure = ({ src, alt, caption, tier = "standard", max, eager = false, imgClassName = "w-full h-auto", className = "", testId }) => (
  <figure className={`${max || TIER_MAX[tier]} ${className}`}>
    <FadeImage src={src} alt={alt} eager={eager} className={imgClassName} testId={testId} />
    <figcaption className="fig-caption mt-3 pb-3 border-b border-hairline">{caption}</figcaption>
  </figure>
);
